module.exports = __webpack_public_path__ + "static/media/yellow-bg-portrait.0176629c.webp";